@if (loadingData) {
  <app-loading-spinner />
} @else {
  <app-wizard
    [wizardType]="WizardType.DIGITAL_SIGNATURE"
    [customerWizardResponse]="customerWizardResponse"
    [brand]="brand"
    [legalEntity]="legalEntity"
    [signatures]="signatures"
    (stepAccepted)="onStepAccepted($event)"
    (stepSkipped)="onStepSkipped($event)"
  />
}
